// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__hcGEu","modal1":"style_modal1__M2aY7","title":"style_title__qxYa3"};